import type { RouteRecordRaw } from 'vue-router';

import { PageType, PurchaseType } from '@/common/enum';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'root',
    redirect: '/index', // 默认重定向到 tungea 品牌宣传页面
  },
  {
    path: '/index',
    name: PageType.Tungea,
    component: () => import('@/views/tungea/index.vue'),
    meta: {
      title: '探鲸-全网通告聚合平台',
      noCache: true,
    },
  },
  {
    path: '/index/:shortCode',
    name: PageType.TungeaWithCode,
    component: () => import('@/views/tungea/index.vue'),
    meta: {
      title: '探鲸-全网通告聚合平台',
      noCache: true,
    },
  },
  {
    path: '/member',
    redirect: `/member/${PurchaseType.MEMBER}`,
  },
  {
    path: '/member/:purchaseType',
    name: PageType.OpenMember,
    component: () => import('@/views/open-member/index.vue'),
    meta: {
      title: '会员广场',
      noCache: false, // 启用缓存
    },
  },
  {
    path: '/open-member-success',
    name: PageType.OpenMemberSuccess,
    component: () => import('@/views/open-member/open-member-success.vue'),
    meta: {
      title: '会员开通成功',
      noCache: true,
    },
  },
  {
    path: '/open-referrer-success',
    name: PageType.OpenReferrerSuccess,
    component: () => import('@/views/open-member/open-referrer-success.vue'),
    meta: {
      title: '推荐官开通成功',
      noCache: true,
    },
  },
  {
    path: '/pages/marketing/claim',
    name: PageType.MarketingClaim,
    component: () => import('@/views/share-vip/index.vue'),
    meta: {
      title: '免费领取探鲸会员',
      noCache: true,
    },
  },
  {
    path: '/baoming-migrate',
    name: PageType.BaomingMigrate,
    component: () => import('@/views/baoming-migrate/index.vue'),
    meta: {
      title: '迁移历史通告与报名数据',
      noCache: true,
    },
  },

  {
    path: '/content-renderer',
    name: PageType.ContentRenderer,
    component: () => import('@/views/operations/content-renderer.vue'),
  },
  {
    path: '/s',
    children: [
      {
        path: 'nd/:shortCode',
        name: PageType.ShareNoticeDetail,
        component: () => import('@/views/share/notice-detail-transition.vue'),
        meta: {
          title: '通告详情',
          noCache: true,
        },
      },
      {
        path: 'tnd/:shortCode',
        name: PageType.TungeaNoticeDetail,
        component: () => import('@/views/share/tungea-notice-detail-transition.vue'),
        meta: {
          title: '通告详情',
          noCache: true,
        },
      },
    ],
  },
  // 短信派单短链不能带 /s/tnd，域名后直接是短码（如 /Wh7hpfm），与 /s/tnd/:shortCode 同一详情页
  {
    path: '/:shortCode([0-9A-Za-z]+)',
    name: PageType.TungeaNoticeDetailShort,
    component: () => import('@/views/share/tungea-notice-detail-transition.vue'),
    meta: {
      title: '通告详情',
      noCache: true,
    },
  },
  {
    path: '/r',
    children: [
      {
        path: 'apd/:shortCode',
        name: PageType.ApplyDataLink,
        component: () => import('@/views/link/index.vue'),
        meta: {
          title: '报名数据',
          noCache: true,
        },
      },
      {
        path: 'dlv/:shortCode',
        name: PageType.DeliverDataLink,
        component: () => import('@/views/deliver-link/index.vue'),
        meta: {
          title: '回传数据',
          noCache: true,
        },
      },
    ],
  },
];

export default routes;
